// Is a given value a DOM element?
export default function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/isElement.js
// module id = 1575
// module chunks = 106